import Layout from "@/layouts/default.vue";

export default [
    {
        path: "/track",
        name: "track",
        component: Layout,
        redirect: "/track/returns",
        meta: {
            title: "物料跟踪",
            icon: "reply_1",
            permission: "manage_accessory_return"
        },
        children: [
            {
                path: "returns",
                name: "track-returns",
                component: () => import("@/views/track/returns.vue"),
                meta: {
                    title: "返回记录",
                    icon: "exchange",
                },
            },
            {
                path: "return-detail/:id",
                name: "track-return-detail",
                component: () => import("@/views/track/return-detail.vue"),
                meta: {
                    title: "返回详情",
                    activeMenu: "/track/returns",
                },
                hidden: true,
            },
            {
                path: "type",
                name: "track-type",
                component: () => import("@/views/track/type.vue"),
                meta: {
                    title: "类型配置",
                    icon: "goods_type",
                },
            },
            {
                path: "overview",
                name: "track-overview",
                component: () => import("@/views/track/overview.vue"),
                meta: {
                    title: "统计分析",
                    icon: "stat",
                },
            },
        ],
    },
];
